import { getUnitTypeByAssetTypeId } from 'store/modules/samples/saga/utils';
import { AssetTypeCode } from 'types/models/asset-type';
import SamplePointStatistic, { CurrentLowHighSummary } from 'types/models/samplePointsStatistic';
import { convertMetricToImperialAlwaysRounding, isUnitTypeConvertible } from 'utils/convert-metric-to-imperial';
import { UnitType } from 'utils/get-unit-by-country';
import { assertIsSamplePointStatisticWithAggregates } from 'utils/SamplePointStatistics/assert-is-with-aggregates';

export const ASSET_TYPES_WITH_CURRENT_LOW_HIGH_SUMMARY: AssetTypeCode[] = [
  AssetTypeCode.BAROMETRIC_PRESSURE,
  AssetTypeCode.DELTA_T,
  AssetTypeCode.DEW_POINT,
  AssetTypeCode.HUMIDITY,
  AssetTypeCode.SOLAR_RADIATION,
  AssetTypeCode.TEMPERATURE
];

export const getCurrentLowHighSummary = (
  assetTypeId: typeof ASSET_TYPES_WITH_CURRENT_LOW_HIGH_SUMMARY[number],
  statistic: SamplePointStatistic,
  country: string
): CurrentLowHighSummary | undefined => {
  try {
    assertIsSamplePointStatisticWithAggregates(statistic);
  } catch (error) {
    // Do nothing. Data is not as expected to compute the intended summary.
    return;
  }
  const unitType: UnitType = getUnitTypeByAssetTypeId(assetTypeId);

  const { aggregates } = statistic;
  const rawCurrent: number | undefined = aggregates.current?.values?.sum ?? undefined;
  const rawDailyLow: number | undefined = aggregates.dailyLow?.values?.sum ?? undefined;
  const rawDailyHigh: number | undefined = aggregates.dailyHigh?.values?.sum ?? undefined;

  if (!isUnitTypeConvertible(unitType)) {
    return {
      current: rawCurrent ?? null,
      dailyLow: rawDailyLow ?? null,
      dailyHigh: rawDailyHigh ?? null
    };
  }

  const current: number | undefined = convertMetricToImperialAlwaysRounding(unitType, country, rawCurrent);
  const dailyLow: number | undefined = convertMetricToImperialAlwaysRounding(unitType, country, rawDailyLow);
  const dailyHigh: number | undefined = convertMetricToImperialAlwaysRounding(unitType, country, rawDailyHigh);

  return {
    current: current ?? null,
    dailyLow: dailyLow ?? null,
    dailyHigh: dailyHigh ?? null
  };
};
